import { render, staticRenderFns } from "./ArticleFilter.component.vue?vue&type=template&id=a0a8b4d8&scoped=true"
import script from "./ArticleFilter.component.vue?vue&type=script&lang=ts"
export * from "./ArticleFilter.component.vue?vue&type=script&lang=ts"
import style0 from "./ArticleFilter.component.vue?vue&type=style&index=0&id=a0a8b4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a8b4d8",
  null
  
)

export default component.exports